<script setup lang="ts">
defineProps<{
  linkText: string
  linkUrl: string
}>()
</script>
<template>
  <a class="flex items-center gap-2 text-mcd-secondaryBlue" :href="linkUrl" target="_blank">
    {{ linkText }}
    <img class="pt-[2px]" src="/images/icons/arrowRightBlue.svg" />
  </a>
</template>
